import type { FC } from "react";
import { useMemo } from "react";

import { percentageSignOnlyFilter } from "app/filters/ngFilters";

import type { IDeviceDistributionPieChartSeries } from "../../types";

import { LegendContainer } from "./ChartLegend.styles";
import { ChartLegendItem } from "./ChartLegendItem";

interface IChartLegendProps {
    items: IDeviceDistributionPieChartSeries[];
    focusedItemName: string;
}

export const ChartLegend: FC<IChartLegendProps> = (props) => {
    const { items, focusedItemName } = props;

    const percentageFilter = useMemo(() => {
        return percentageSignOnlyFilter();
    }, []);

    return (
        <LegendContainer>
            {items.map((item) => {
                const isFocused = !focusedItemName || focusedItemName === item.name;
                const itemValue = item.y ? percentageFilter(item.y, 2) : "%";

                return (
                    <ChartLegendItem
                        key={item.seriesName}
                        name={item.name}
                        value={itemValue}
                        color={item.color}
                        isFocused={isFocused}
                    />
                );
            })}
        </LegendContainer>
    );
};
